import { Route, Routes, useLocation } from "react-router";
import LeftPanel from "../layout/leftPanel/LeftPanel";
import RightPanel from "../layout/RightPanel";
import EmptyMessagePanelView from "../message/EmptyMessagePanel";
import { MESSAGE_ROUTE_PATTERNS, SECTION_ROUTE_PATTERNS } from "../routes";
import { IChatRoutes } from "./IChatRoutes";
import { RouteProvider } from "hhn-commons";
import { UnsentMessagesGuardProvider } from "../context/UnsentMessagesGuardProvider";

const ChatRoutes = () => {
  const { state } = useLocation();

  const getFocusMessageId = () => {
    return state?.focusMessageId;
  };

  const clearFocusMessageId = () => {
    if (state) {
      state.focusMessageId = undefined;
    }
  };

  return (
    <UnsentMessagesGuardProvider>
      <Routes>
        <Route path="*" element={<LeftPanel />} />
      </Routes>
      <Routes>
        {MESSAGE_ROUTE_PATTERNS.map((path, index) => (
          <Route
            key={"chat-message-" + index}
            path={path}
            element={
              <RouteProvider<IChatRoutes>
                routes={{
                  getFocusMessageId,
                  clearFocusMessageId,
                }}
              >
                <RightPanel />
              </RouteProvider>
            }
          />
        ))}
        {SECTION_ROUTE_PATTERNS.map((path, index) => (
          <Route
            key={"section-" + index}
            path={path}
            element={<EmptyMessagePanelView />}
          />
        ))}
      </Routes>
    </UnsentMessagesGuardProvider>
  );
};

export default ChatRoutes;
